import React, { useEffect, useRef } from "react";
import PopupStyle from "../../style/PopUp.module.css";
import Style from "../../style/Pages/Auth/AuthPassword.module.css";
import images from "../../utils/images";
import { faEyeSlash, faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import AuthPassInputField from "../../components/ui/input/AuthInputs/AuthInputPassword";
import Button from "../../components/ui/buttons/Button";
import { useChangePassword } from "../../hooks/useAuth";
import { Loader } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { useState } from "react";

const ChangePassword = ({ OnClose }) => {
  const { formData, loading, errors, handleInputChange, handleSubmit } =
    useChangePassword();

  const [showPassword, setShowPassword] = React.useState({
    current: false,
    new: false,
    confirm: false,
  });

  const modalRef = useRef(null);

  // Detect outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        OnClose(); // Close the modal
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [OnClose]);

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };
  const calculatePasswordStrength = (password) => {
    if (!password) return 0;

    let strength = 0;

    // Length
    if (password.length >= 8) strength += 25;
    if (password.length >= 12) strength += 15;

    // Character diversity
    if (/[A-Z]/.test(password)) strength += 15;
    if (/[0-9]/.test(password)) strength += 15;
    if (/[!@#$%^&*]/.test(password)) strength += 15;

    // Additional complexity
    if (password.length > 14) strength += 15;

    return Math.min(strength, 100);
  };

  const getStrengthColor = (strength) => {
    if (strength < 30) return "#ff4d4d";
    if (strength < 60) return "#ffa500";
    if (strength < 80) return "#87ceeb";
    return "#32cd32";
  };

  const strength = calculatePasswordStrength(formData.new_password);
  const strengthColor = getStrengthColor(strength);

  return (
    <div className={PopupStyle.popupBackground}>
      <div className={Style.authPasswordContainer} ref={modalRef}>
        <div className={Style.authPasswordMain}>
          <div className={Style.closeIcon} onClick={OnClose}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
          <div className={Style.authHeaderSection}>
            <div>
              {" "}
              <div className={Style.authHeadImg}>
                <img alt="img" src={images.changepassword} />
              </div>
              <h2>Change Password</h2>
              <p>Here, you can change your password.</p>
            </div>
          </div>
          <div className={Style.authPasswordContent}>
            <AuthPassInputField
              label="Current Password"
              value={formData.old_password}
              onChange={(e) =>
                handleInputChange("old_password", e.target.value)
              }
              type={showPassword.current ? "text" : "password"}
              placeholder="Enter current password"
              error={errors.old_password}
              icon={showPassword.current ? faEye : faEyeSlash}
              onIconClick={() => togglePasswordVisibility("current")}
              required
            />
            <AuthPassInputField
              label="New Password"
              value={formData.new_password}
              onChange={(e) =>
                handleInputChange("new_password", e.target.value)
              }
              type={showPassword.new ? "text" : "password"}
              placeholder="Enter new password"
              error={errors.new_password}
              icon={showPassword.new ? faEye : faEyeSlash}
              onIconClick={() => togglePasswordVisibility("new")}
              required
            />
            <div className={Style.passwordstrengthmeter}>
              <div
                className={Style.strengthbar}
                style={{
                  width: `${strength}%`,
                  backgroundColor: strengthColor,
                }}
              ></div>
            </div>
            <div className={Style.strengthlabel}>
              Password strength:
              <span style={{ color: strengthColor }}>
                {strength < 30
                  ? " Weak"
                  : strength < 60
                  ? " Fair"
                  : strength < 80
                  ? " Good"
                  : " Strong"}
              </span>
            </div>

            <div className={Style.passwordrequirements}>
              <p>Password must contain:</p>
              <ul>
                <li
                  className={
                    formData.new_password.length >= 8 ? `${Style.valid}` : ""
                  }
                >
                  At least 8 characters
                </li>
                <li
                  className={
                    /[A-Z]/.test(formData.new_password) ? `${Style.valid}` : ""
                  }
                >
                  One uppercase letter
                </li>
                <li
                  className={
                    /[0-9]/.test(formData.new_password) ? `${Style.valid}` : ""
                  }
                >
                  One number
                </li>
                <li
                  className={
                    /[!@#$%^&*]/.test(formData.new_password)
                      ? `${Style.valid}`
                      : ""
                  }
                >
                  One special character
                </li>
              </ul>
            </div>
            <AuthPassInputField
              label="Confirm Password"
              value={formData.confirm_password}
              onChange={(e) =>
                handleInputChange("confirm_password", e.target.value)
              }
              type={showPassword.confirm ? "text" : "password"}
              placeholder="Confirm new password"
              error={errors.confirm_password}
              icon={showPassword.confirm ? faEye : faEyeSlash}
              onIconClick={() => togglePasswordVisibility("confirm")}
              required
            />
            <div>
              <Button onClick={handleSubmit}>
                {/* Submit */}
                {loading ? <Loader /> : "Submit"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
